module.exports = __webpack_public_path__ + "img/banner-loading-2.b2af705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/project/loader/banner-loading-2.jpg
// module id = 51ow
// module chunks = 9